// extracted by mini-css-extract-plugin
export default {"head":"Head_head__uvd2T","bold":"Head_bold__f1IzQ","medium":"Head_medium__1TA24"};